import React, { useState } from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import pdfCSS from './pdf.module.css';

export function PdfModal({ product }) {
    const { name } = product.data.attributes;
    const katalog = product.data.attributes.produktKatalog;

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (katalog && katalog.data && katalog.data.length > 0) {
        const fileUrl = katalog.data[0].attributes.url;
        const fileType = fileUrl.split('.').pop().toLowerCase();

        return (
            <>
                <div className={pdfCSS.thumbnailContainer} onClick={handleShow} style={{ cursor: 'pointer' }}>
                    {fileType === 'pdf' ? (
                        <>
                            <div className={pdfCSS.underoverskrift}>
                                Åpne produktkatalog
                            </div>
                            <iframe
                                src={`${fileUrl}#page=1`}
                                style={{ width: '100px', height: '100px', border: 'none', overflow: 'hidden' }}
                                title="PDF Thumbnail"
                                className='m-auto'
                            />
                            <div className={pdfCSS.overlay}></div>
                        </>
                    ) : (
                        <Image src={fileUrl} fluid alt={name} style={{ width: '100px' }} />
                    )}
                </div>

                <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={pdfCSS.modal}>
                        {fileType === 'pdf' ? (
                            <iframe
                                src={fileUrl}
                                frameBorder="0"
                                style={{ width: '100%', height: '750px', overflow: 'hidden' }}
                                title="PDF Document"
                            />
                            // <iframe
                            //     src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                            //     style={{ width: '100%', height: '750px' }}
                            //     frameBorder="0"
                            //     title="PDF Document"
                            // />
                        ) : (
                            <Image src={fileUrl} fluid alt={name} />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className={pdfCSS.closeButton} onClick={handleClose}>
                            Lukk
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
    return null;
}

export default PdfModal;

// import React, { useState } from 'react';
// import { Button } from 'react-bootstrap';
// import { Modal } from 'react-bootstrap';
// import { Image } from 'react-bootstrap';
// import pdfCSS from './pdf.module.css';
// import { Worker, Viewer } from '@react-pdf-viewer/core';
// import '@react-pdf-viewer/core/lib/styles/index.css';
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// export function PdfModal({ product }) {
//     const { name } = product.data.attributes;
//     const katalog = product.data.attributes.produktKatalog;

//     const pdfIcon = product.data.attributes.produktKatalog.data[0].attributes.url;

//     const [show, setShow] = useState(false);
//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     const defaultLayoutPluginInstance = defaultLayoutPlugin();

//     if (katalog && katalog.data && katalog.data.length > 0) {
//         const fileUrl = product.data.attributes.produktKatalog.data[0].attributes.url;
//         const fileType = fileUrl.split('.').pop().toLowerCase();

//         return (
//             <>
//                 <div className={pdfCSS.openButton}>
//                     {fileType === 'pdf' ? (
//                         <div className='d-flex align-items-center col-5 m-auto justify-content-between' onClick={handleShow}>
//                             <div className='col-4'>
//                                 <Image src={pdfIcon} fluid alt={name} />
//                             </div>
//                             Datablad
//                         </div>
//                     ) : (
//                         <Image src={fileUrl} fluid alt={name} onClick={handleShow} />
//                     )}
//                 </div>

//                 <Modal show={show} onHide={handleClose} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>{name}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body className={pdfCSS.modal}>
//                         {fileType === 'pdf' ? (
//                             <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js`}>
//                                 <div style={{ height: '750px' }}>
//                                     <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]} />
//                                 </div>
//                             </Worker>
//                         ) : (
//                             <Image src={fileUrl} fluid alt={name} />
//                         )}
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button className={pdfCSS.closeButton} onClick={handleClose}>
//                             Lukk
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>
//             </>
//         );
//     }
//     return null;
// }

// export default PdfModal;




// import React, { useState, useEffect } from 'react';
// import { Button, Modal, Image } from 'react-bootstrap';
// import { Document, Page } from 'react-pdf';
// import pdfCSS from './pdf.module.css';

// export function PdfModal({ product }) {
//     const { name } = product.data.attributes;
//     const katalog = product.data.attributes.produktKatalog;

//     const [show, setShow] = useState(false);
//     const [numPages, setNumPages] = useState(null);

//     useEffect(() => {
//         const loadPdfJsWorker = async () => {
//             const pdfjs = await import('pdfjs-dist/build/pdf');
//             const pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry');

//             pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
//         };

//         loadPdfJsWorker();
//     }, []);

//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     const onDocumentLoadSuccess = ({ numPages }) => {
//         setNumPages(numPages);
//     };

//     if (katalog && katalog.data && katalog.data.length > 0) {
//         const fileUrl = katalog.data[0].attributes.url;
//         const fileType = fileUrl.split('.').pop().toLowerCase();

//         return (
//             <>
//                 <div className={pdfCSS.openButton} onClick={handleShow}>
//                     {fileType === 'pdf' ? (
//                         <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
//                             <Page pageNumber={1} width={100} renderTextLayer={false} renderAnnotationLayer={false} />
//                         </Document>
//                     ) : (
//                         <Image src={fileUrl} fluid alt={name} style={{ width: '100px', cursor: 'pointer' }} />
//                     )}
//                 </div>

//                 <Modal show={show} onHide={handleClose} size="lg">
//                     <Modal.Header closeButton>
//                         <Modal.Title>{name}</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body className={pdfCSS.modal}>
//                         {fileType === 'pdf' ? (
//                             <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
//                                 {Array.from({ length: numPages }, (_, index) => (
//                                     <Page key={`page_${index + 1}`} pageNumber={index + 1} />
//                                 ))}
//                             </Document>
//                         ) : (
//                             <Image src={fileUrl} fluid alt={name} />
//                         )}
//                     </Modal.Body>
//                     <Modal.Footer>
//                         <Button className={pdfCSS.closeButton} onClick={handleClose}>
//                             Lukk
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>
//             </>
//         );
//     }
//     return null;
// }

// export default PdfModal;